import { Injectable } from "@/di/injectable";

import { HttpService } from "./sxhr";

import type { AnonymousId } from "@/interface/api";

@Injectable({ scope: "singleton", deep: [HttpService] })
export class UserService {
  http!: HttpService;
  constructor(http: HttpService) {
    this.http = http;
  }

  getUserId(id?: string): Promise<AnonymousId> {
    return this.http.sxhr<unknown, AnonymousId>({
      path: "api/user/anonymous",
      data: id !== undefined ? { anonymous_id: id } : undefined,
    });
  }
}
